/**
 * Demo lead records, lifted verbatim from the prototype's
 * `docs/html/assets/js/leads-data.js` so the React screens show the same rows
 * the design was reviewed against.
 *
 * These are fixtures, not a data layer. `GET /v1/leads` answers 501 until
 * `docs/API.md` §4 is implemented; `mockFallback` serves these in the meantime
 * and stops the moment the real endpoint exists.
 *
 * Engagement counters (opens/replies/visits/meetings) feed the configurable
 * scoring rules the Lead Scoring panel renders.
 */
export const leads = [
  { id:'LD-00184', name:'Sofia Marchetti', title:'Head of Operations', company:'Northwind Analytics',
    email:'s.marchetti@northwind.io', phone:'+1 415 555 0142', source:'LinkedIn', score:92, rating:'Hot',
    status:'Qualified', value:185000, owner:'Aisha Kapoor', followup:'Today 11:00', overdue:false,
    industry:'Data & Analytics', employees:1200, country:'United States', campaign:'Q3 LinkedIn ABM',
    opens:11, replies:3, visits:18, meetings:1 },
  { id:'LD-00179', name:'Ravi Deshmukh', title:'VP Engineering', company:'Helix Robotics',
    email:'r.deshmukh@helixrobotics.com', phone:'+48 22 555 0188', source:'Exhibition', score:88, rating:'Hot',
    status:'Working', value:96000, owner:'Marek Kowalski', followup:'Today 14:30', overdue:false,
    industry:'Manufacturing', employees:840, country:'Poland', campaign:'Manufacturing Expo',
    opens:7, replies:2, visits:9, meetings:1 },
  { id:'LD-00176', name:'Grace Adeyemi', title:'Procurement Lead', company:'Meridian Health',
    email:'g.adeyemi@meridianhealth.com', phone:'+1 617 555 0119', source:'Referral', score:86, rating:'Hot',
    status:'Nurturing', value:210000, owner:'Aisha Kapoor', followup:'Overdue 2d', overdue:true,
    industry:'Healthcare', employees:3400, country:'United States', campaign:'Partner Referral',
    opens:6, replies:1, visits:12, meetings:0 },
  { id:'LD-00171', name:'Tomas Berg', title:'CTO', company:'Vertex Media',
    email:'t.berg@vertexmedia.co.uk', phone:'+44 20 7555 0164', source:'Web', score:83, rating:'Hot',
    status:'Qualified', value:64000, owner:'Sara Brandt', followup:'Tomorrow', overdue:false,
    industry:'Media', employees:410, country:'United Kingdom', campaign:'Website — pricing page',
    opens:9, replies:2, visits:14, meetings:1 },
  { id:'LD-00168', name:'Lena Okonjo', title:'Director, Operations', company:'Cobalt Energy',
    email:'l.okonjo@cobaltenergy.no', phone:'+47 22 555 0173', source:'Advertisement', score:81, rating:'Hot',
    status:'New', value:132000, owner:'Unassigned', followup:null, overdue:false,
    industry:'Energy & Utilities', employees:2100, country:'Norway', campaign:'Search advertising',
    opens:2, replies:0, visits:4, meetings:0 },
  { id:'LD-00164', name:'Hugo Alvarez', title:'CFO', company:'Solaris Retail',
    email:'h.alvarez@solarisretail.es', phone:'+34 91 555 0127', source:'Google', score:74, rating:'Warm',
    status:'Working', value:58000, owner:'Diego Ramos', followup:'04 Sep', overdue:false,
    industry:'Retail', employees:620, country:'Spain', campaign:'Search advertising',
    opens:5, replies:1, visits:7, meetings:0 },
  { id:'LD-00159', name:'Mei Tanaka', title:'Head of IT', company:'Kyoto Systems',
    email:'m.tanaka@kyotosystems.jp', phone:'+81 75 555 0198', source:'Partner', score:71, rating:'Warm',
    status:'Qualified', value:144000, owner:'Jonas Weber', followup:'05 Sep', overdue:false,
    industry:'Technology', employees:980, country:'Japan', campaign:'Partner Referral',
    opens:8, replies:2, visits:11, meetings:1 },
  { id:'LD-00155', name:'Peter Novak', title:'Plant Manager', company:'Danube Steel',
    email:'p.novak@danubesteel.cz', phone:'+420 2 5555 0141', source:'Cold Call', score:66, rating:'Warm',
    status:'Nurturing', value:87000, owner:'Marek Kowalski', followup:'06 Sep', overdue:false,
    industry:'Manufacturing', employees:1500, country:'Czechia', campaign:'—',
    opens:3, replies:0, visits:5, meetings:0 },
  { id:'LD-00151', name:'Amara Bello', title:'COO', company:'Lagos Freight',
    email:'a.bello@lagosfreight.ng', phone:'+234 1 555 0136', source:'Exhibition', score:59, rating:'Warm',
    status:'Working', value:41000, owner:'Chloe Dubois', followup:'Overdue 1d', overdue:true,
    industry:'Logistics', employees:280, country:'Nigeria', campaign:'Manufacturing Expo',
    opens:4, replies:1, visits:3, meetings:0 },
  { id:'LD-00147', name:'Erik Lund', title:'Buyer', company:'Fjord Marine',
    email:'e.lund@fjordmarine.no', phone:'+47 55 555 0112', source:'Web', score:48, rating:'Cold',
    status:'New', value:29000, owner:'Unassigned', followup:null, overdue:false,
    industry:'Marine', employees:130, country:'Norway', campaign:'Website — contact form',
    opens:1, replies:0, visits:2, meetings:0 },
  { id:'LD-00142', name:'Claire Bennett', title:'Marketing Director', company:'Aurora Logistics',
    email:'c.bennett@auroralogistics.fr', phone:'+33 1 55 55 0175', source:'Email campaign', score:44, rating:'Cold',
    status:'Unqualified', value:18000, owner:'Sara Brandt', followup:null, overdue:false,
    industry:'Logistics', employees:760, country:'France', campaign:'Webinar series',
    opens:2, replies:0, visits:1, meetings:0 },
  { id:'LD-00138', name:'Omar Haddad', title:'Owner', company:'Atlas Traders',
    email:'o.haddad@atlastraders.ae', phone:'+971 4 555 0159', source:'Referral', score:37, rating:'Cold',
    status:'Unqualified', value:12000, owner:'Diego Ramos', followup:null, overdue:false,
    industry:'Wholesale', employees:45, country:'UAE', campaign:'—',
    opens:0, replies:0, visits:0, meetings:0 }
];
